<template>
  <BreadCrumb PageTitle="Float" />
  <FloatContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import FloatContent from "../../template-components/Utilities/Float/FloatContent.vue";

export default defineComponent({
  name: "FloatPage",
  components: {
    BreadCrumb,
    FloatContent,
  },
});
</script>